module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_green_en-c7b386a9aa5f241a11738e7bc3a61ccb.png";